(() => {
  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `€${(cents / 100).toFixed(2)}`;
    }
  };

  const imageUrl = (image) => {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  };

  const withWidth = (url, width) => {
    if (!url || /([?&])width=/.test(url)) return url || '';
    return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
  };

  document.querySelectorAll('[data-product-surface]').forEach((surface) => {
    const productJson = surface.querySelector('[data-product-json]');
    const matrixJson = surface.querySelector('[data-variant-matrix]');
    const form = surface.querySelector('.imagvo-product-form');
    if (!productJson || !matrixJson || !form) return;

    let product;
    let matrix;
    try {
      product = JSON.parse(productJson.textContent);
      matrix = JSON.parse(matrixJson.textContent);
    } catch (_) {
      return;
    }

    product.variants = Array.isArray(matrix.variants) ? matrix.variants : [];
    product.title = matrix.title || product.title;
    product.featured_image = matrix.featured_image || product.featured_image;

    const groups = Array.from(form.querySelectorAll('.variant-group'));
    const initialImage = surface.querySelector('.hero-product-image');
    const defaultImage = initialImage ? initialImage.getAttribute('src') : '';
    groups.forEach(group => group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; }));

    const selectedOptions = () => groups.map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });

    const selectedOptionIds = () => groups.map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? String(checked.dataset.optionValueId || '') : '';
    });

    const findLocalVariant = () => {
      const selectedIds = selectedOptionIds();
      const idMatch = product.variants.find((variant) =>
        Array.isArray(variant.option_value_ids) &&
        selectedIds.every((value, index) => value && value === String(variant.option_value_ids[index] || ''))
      );
      if (idMatch) return idMatch;

      const selected = selectedOptions();
      return product.variants.find((variant) =>
        selected.every((value, index) => value === variant.options[index])
      );
    };

    const variantImage = (variant) => {
      // Only ever use this exact variant's own assigned image. Borrowing a
      // photo from a "similar" sibling variant (e.g. same pack size but a
      // different finish/color) showed the wrong photo whenever that sibling
      // happened to have media and the real combo didn't. Falling back to the
      // product's default photo is always correct; guessing a sibling's isn't.
      return variant.image
        || defaultImage
        || imageUrl(product.featured_image)
        || imageUrl(product.images && product.images[0]);
    };

    const renderVariant = (variant) => {
      if (!variant) {
        const id = form.querySelector('[data-variant-id]');
        if (id) { id.value = ''; id.setAttribute('value', ''); }
        delete form.dataset.selectedVariantId;
        delete surface.dataset.currentVariantId;
        const button = form.querySelector('.add-button');
        if (button) button.disabled = true;
        const price = form.querySelector('[data-price]');
        if (price) price.textContent = '';
        form.dispatchEvent(new CustomEvent('imagvo:variant-change', { detail: { variant: null } }));
        return;
      }

      const id = form.querySelector('[data-variant-id]');
      const price = form.querySelector('[data-price]');
      const button = form.querySelector('.add-button');
      const label = form.querySelector('[data-add-label]');
      const image = surface.querySelector('.hero-product-image');

      if (id) {
        id.value = variant.id;
        id.setAttribute('value', variant.id);
      }
      form.dataset.selectedVariantId = String(variant.id);
      if (price) price.textContent = money(variant.price);
      if (button) button.disabled = !variant.available;
      if (label) {
        const addLabel = surface.dataset.addToCartLabel || 'Add to cart';
        const soldOutLabel = surface.dataset.soldOutLabel || 'Sold out';
        label.textContent = variant.available ? addLabel : soldOutLabel;
      }

      const nextImage = variantImage(variant);
      if (image && nextImage) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = withWidth(nextImage, 1800);
        image.alt = product.title || image.alt;
      }

      surface.dataset.currentVariantId = String(variant.id);
      form.dispatchEvent(new CustomEvent('imagvo:variant-change', { bubbles: false, detail: { variant } }));
    };

    const updateOptionPrices = () => {
      const current = selectedOptions();
      const currentIds = selectedOptionIds();
      const prefix = surface.dataset.pricePrefix || 'From';

      groups.forEach((group, optionIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const label = input.nextElementSibling;
          const price = label && label.querySelector('[data-option-price]');
          if (!price) return;

          const inputOptionId = String(input.dataset.optionValueId || '');

          if (optionIndex === 0) {
            const prices = product.variants
              .filter((variant) => {
                const variantOptionId = String((variant.option_value_ids || [])[0] || '');
                // Only trust the id match when BOTH sides actually have an id —
                // two blank ids are not the same option value, they're just
                // both missing, and comparing them as equal ("" === "") used to
                // match every variant at once, collapsing all the per-value
                // price hints into one blanket (usually wrong) number.
                if (inputOptionId && variantOptionId) return variantOptionId === inputOptionId;
                return variant.options[0] === input.value;
              })
              .map((variant) => variant.price);
            price.textContent = prices.length ? `${prefix} ${money(Math.min(...prices))}` : '';
            return;
          }

          const candidate = current.slice();
          candidate[optionIndex] = input.value;
          const candidateIds = currentIds.slice();
          candidateIds[optionIndex] = inputOptionId;
          const variant = product.variants.find((item) =>
            Array.isArray(item.option_value_ids) &&
            candidateIds.every((value, index) => value && value === String(item.option_value_ids[index] || ''))
          ) || product.variants.find((item) =>
            candidate.every((value, index) => value === item.options[index])
          );
          price.textContent = variant ? money(variant.price) : '';
        });
      });
    };

    const updateUrl = (variant) => {
      // IMPORTANT: this product picker is also rendered on the homepage.
      // Never replace the homepage pathname with /products/... just because
      // a variant was selected. Doing that leaves the DOM looking like the
      // homepage while the address bar points at the product page. If the
      // browser later restores/reloads the document (for example around the
      // native file picker), Shopify then loads the real product template and
      // every homepage section below the uploader disappears.
      if (!variant) return;

      const isHomepageSurface = !!surface.closest('.home-product');
      const url = isHomepageSurface
        ? new URL(window.location.href)
        : new URL(surface.dataset.productUrl || window.location.href, window.location.origin);

      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const update = () => {
      updateOptionPrices();
      const variant = findLocalVariant();
      renderVariant(variant);
      updateUrl(variant);
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('.variant-group input[type="radio"]')) update();
    });

    updateOptionPrices();
    renderVariant(findLocalVariant());
  });

  // Reviews carousel: left/right arrows scroll the track, buttons disable
  // themselves at either end so it's clear when there's nothing more to see.
  document.querySelectorAll('[data-reviews-track]').forEach((track) => {
    const carousel = track.closest('.reviews-carousel');
    if (!carousel) return;
    const prevBtn = carousel.querySelector('[data-reviews-prev]');
    const nextBtn = carousel.querySelector('[data-reviews-next]');

    const updateArrows = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 4;
    };

    const scrollByCard = (direction) => {
      const card = track.querySelector('.reviews-card');
      const amount = card ? card.getBoundingClientRect().width + 32 : 320;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  // Click-to-enlarge lightbox for review photos (and anything else that
  // opts in with data-lightbox-trigger).
  const lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    const lightboxImg = lightbox.querySelector('[data-lightbox-image]');
    const closeBtn = lightbox.querySelector('[data-lightbox-close]');

    const openLightbox = (src, alt) => {
      if (!lightboxImg) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    const closeLightbox = () => {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lightboxImg) lightboxImg.src = '';
    };

    document.querySelectorAll('[data-lightbox-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openLightbox(trigger.dataset.lightboxSrc, trigger.dataset.lightboxAlt);
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }
})();
